import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import service from "../services/factura_venta.service";

const initialState = {
    facturas: [],
    factura: null,
    isLoading: false,
    isError: false,
    message: '',
    currentPage: 1,
    totalRows: 0,
    siguienteNumero: null, // Agrega esta propiedad para almacenar el siguiente número de factura
};


export const getFacturas = createAsyncThunk(
    "facturas/getFacturas",
    async (data, thunkAPI) => {
        try {
            return await service.getAllFacturas(data);
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)
export const createFactura = createAsyncThunk(
    "factura/create",
    async (facturaData, thunkAPI) => {
        try {
            return await service.createFactura(facturaData);
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const updateFactura = createAsyncThunk(
    "factura/update",
    async (facturaData, thunkAPI) => {
        try {
            return await service.updateFactura(facturaData);
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const deleteFactura = createAsyncThunk(
    "factura/delete",
    async (id, thunkAPI) => {
        try {
            return await service.deleteFactura(id);
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

// Acción para obtener una factura por ID
export const getFacturaById = createAsyncThunk(
    'facturas/getFacturaById',
    async (id, thunkAPI) => {
        try {
            return await service.getFacturaById(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const facturaVentaSlice = createSlice({
    name: "facturas",
    initialState,
    reducers: {
        reset: (state) => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFacturas.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getFacturas.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.facturas = action.payload.data; // Asegúrate de que el backend retorne los datos bajo esta estructura
                state.currentPage = action.payload.pagination.por_pagina;
                state.totalRows = action.payload.pagination.cantidad;
            })
            .addCase(getFacturas.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(createFactura.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createFactura.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.facturas.push(action.payload); // Agrega la nueva factura a la lista
                state.message = action.payload;
            })
            .addCase(createFactura.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updateFactura.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateFactura.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                const index = state.facturas.findIndex(factura => factura.id === action.payload.id);
                if (index !== -1) {
                    state.facturas[index] = action.payload; // Actualiza la factura existente
                }
                state.message = action.payload;
            })
            .addCase(updateFactura.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(deleteFactura.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteFactura.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.facturas = state.facturas.filter(factura => factura.id !== action.payload.id); // Elimina la factura de la lista
                state.message = action.payload;
            })
            .addCase(deleteFactura.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(getFacturaById.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getFacturaById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.factura = action.payload;
            })
            .addCase(getFacturaById.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload || 'Error al cargar la factura';
            });
       
    }
})

export const { reset } = facturaVentaSlice.actions;
export default facturaVentaSlice.reducer;